import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";

import SearchableSelect from "util/component/SearchableSelect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";

import axios from 'util/axios';

import { useTranslation } from "react-i18next";

import "./styles.scss";

import ModalPortal from "util/component/Modal";
import { Confirm, Modal } from "util/component/Modal/Modal";

import { useDispatch, useSelector } from "react-redux";

import { PreviewContainer } from "util/component/CKEditorPreview";

import ReviewComponent from "util/component/Review";

import DescEditor from "./Components/DescEditor";
import UnconfirmedList from "./Components/UnconfirmedList";

const EditList = ["descHeader", "descCommon", "descFooter"];
// const EditList = ["descHeader"];

const javascript_handler = (event) => {
    const { target } = event;
    const isTarget = target?.closest("[data-uniquecode]");
    if (isTarget) {
        return;
    }
};

const MainDesc = () => {
    const dispatch = useDispatch();
    const userSelector = useSelector((store) => store.user);
    const EditorRef = useRef([]);
    const { t } = useTranslation(["page"]);

    const [ConfirmOpen, SetConfirmOpen] = useState(false);
    const [ModalOpen, SetModalOpen] = useState(false);
    const [PreviewOpen, SetPreviewOpen] = useState(null);

    const [data, setData] = useState(null);

    const [RevisionList, SetRevisionList] = useState(null);

    const [projects, setProjects] = useState([]);
    const [inputs, setInputs] = useState({
        projectNm: "",
        processCd: "",
    });
    const procList = [
        { label: "USP", value: "USP" },
        { label: "DSP", value: "DSP" },
    ];
    const isTempExist = useRef(false);

    const [ReviewOpen, SetReviewOpen] = useState(null);

    useEffect(() => {
        window.removeEventListener("click", javascript_handler);
        window.addEventListener("click", javascript_handler);
    }, []);

    const getProjects = async () => {
        dispatch({ type: "LOADING_ON" });
        try {
            const response = await axios.post(process.env.REACT_APP_API + "/common/retrieveMasterCodeList", {
                grcd: "PROJECT",
                disableYn: "N",
            });
            const result = response.data.data.result;
            setProjects(result);
            SetRevisionList(null);
            setData(null);
            isTempExist.current = false;
        } catch (e) {
            console.error(e);
            alert("ERROR");
        } finally {
            dispatch({ type: "LOADING_OFF" });
        }
    };

    const getDesc = async () => {
        dispatch({ type: "LOADING_ON" });
        try {
            const response = await axios.post(process.env.REACT_APP_API + "/pcsDesc/retrieveDescMaster", inputs);

            const data = response.data.data;
            let rev_data = [];

            if (data?.result?.descCode) {
                const rev_response = await axios.post(process.env.REACT_APP_API + "/pcsReview/findRevCmptCheck", {
                    sheetcd: data.result.descCode,
                    revision: data.result.revision,
                    tempYn: data.result.tempYn,
                });
                rev_data = rev_response?.data?.data?.result || [];
            }

            isTempExist.current = data?.tempYn === "Y" ? true : false;
            setData({ ...data.result, tempYn: data?.tempYn, maxRevision: data.result.revision, reviewData: rev_data,lastUserNm : "",lastVer: data.result.revision,lastUserId: "" });
        } catch (e) {
            console.error(e);
        }
        dispatch({ type: "LOADING_OFF" });
    };

    useEffect(() => {
        if (projects.length < 1) {
            getProjects();
        }
        if (inputs?.projectNm && inputs?.processCd) {
            getDesc();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputs, projects.length]);

    useEffect(() => {
        if (!data) return;
        let list = null;
        const { maxRevision } = data;
        if (maxRevision > -1) {
            list = new Array(maxRevision).fill().map((e, i) => {
                return { label: i + 1, value: i + 1 };
            });
            if (isTempExist.current) {
                list.push({ label: maxRevision, value: maxRevision + "T", temp: "Y" });
            }
            SetRevisionList(list);
        }
        return () => {
            SetRevisionList(null);
        };
    }, [data]);

    useEffect(() => {
        SetReviewOpen(null);
    }, [data?.processCd]);

    const confirmValid = () => {
        let valid = true;
        const el = document.getElementById("saveMsg");

        valid = !!el.value;
        if (!valid) {
            document.getElementById("mainFormSaveSpan").classList.remove("valid");
        }
        return valid;
    };

    const handleConfirmValid = () => {
        document.getElementById("mainFormSaveSpan").classList.add("valid");
    };

    const onConfirm = (close) => {
        let valid = confirmValid();

        if (valid) {
            const el = document.getElementById("saveMsg");
            close(false);
            SaveFormData({ msg: el.value });
        }
    };

    const RevisionChange = async (selected) => {
        SetReviewOpen(null);
        if (selected.temp === "Y") {
            return getDesc();
        }
        dispatch({ type: "LOADING_ON" });

        const OLD_DATA = { ...data };
        try {
            const response = await axios.post(process.env.REACT_APP_API + "/pcsDesc/retrieveDescMasterByRevision", {
                descCode: data.descCode,
                revision: selected.value.toString().replace(/\D/g, ""),
            });
            const data2 = response.data.data;
            let rev_data = [];

            if (data2?.result?.descCode) {
                const rev_response = await axios.post(process.env.REACT_APP_API + "/pcsReview/findRevCmptCheck", {
                    sheetcd: data2.result?.descCode,
                    revision: data2.result?.revision,
                    tempYn: data2.result?.tempYn,
                });
                rev_data = rev_response?.data?.data?.result || [{revData:"nodata"}];

            }

            setData({ ...data2?.result,lastUserNm : data2.owner.userNm ,lastVer : data2.owner.revision ,lastUserId : data2.owner.userId , tempYn: data2?.result.tempYn || undefined, maxRevision: OLD_DATA.maxRevision,reviewData: rev_data  });
        } catch (e) {
            console.error(e);
        }
        dispatch({ type: "LOADING_OFF" });
    };

    // Save

    const removeDuplicateCodeAndReturnData = (i) => {
        let data = EditorRef.current[i].getData();
        let chk = document.createElement("div");
        chk.innerHTML = data;
        chk.querySelectorAll("[data-uniquecode]").forEach((e) => {
            const uniquecode = e.dataset.uniquecode;
            const chkcnt = chk.querySelectorAll(`[data-uniquecode=${uniquecode}]`);
            if (chkcnt.length > 1) {
                let flag = false;
                
                for (let i = 0; i < chkcnt.length; i++) {
                    if(!chkcnt[i].innerText.replaceAll(/[\W]+/g,"") || flag) {
                        chkcnt[i]?.removeAttribute("data-uniquecode");
                    } else {
                        flag = true;
                    }
                }
            }
        });
        return chk.innerHTML;
    };

    const SaveFormData = async ({ msg }) => {
        let formData = {};
        EditList.forEach((v, i) => {
            formData = { ...formData, [v]: removeDuplicateCodeAndReturnData(i) };
        });
        formData = {
            ...data,
            ...formData,
            ...inputs,
            revision: (data.maxRevision || 0) + (!!msg && 1),
            userId: userSelector.userId,
            revisionLog: msg,
            message: msg,
            projectNm : inputs.projectNm,
            processCd : inputs.processCd
        };
        dispatch({ type: "LOADING_ON" });
        try {
            if (msg) {
                const response = await axios.post(process.env.REACT_APP_API + "/pcsDesc/createDescMaster", formData);
                if (response.data.data.result === "MSG101") {
                    SetModalOpen(<Modal onClose={() => SetModalOpen(null)}>{t("MSG101")}</Modal>);
                } else if(response.data.data.result === "ERR105") {
                    SetModalOpen(<Modal onClose={() => SetModalOpen(null)}>{t("ERR105")}</Modal>);
                } else if(response.data.data.result === "ERR111") {
                    SetModalOpen(<Modal onClose={() => SetModalOpen(null)}>{t("ERR111")}</Modal>);
                } else {
                    SetModalOpen(<Modal onClose={() => SetModalOpen(null)}>{t("saved")}</Modal>);
                }
            } else {
                const response = await axios.post(process.env.REACT_APP_API + "/pcsDesc/createDescMasterTemp", formData);
                SetModalOpen(<Modal onClose={() => SetModalOpen(null)}>{t("saved")}</Modal>);
            }
        } catch (e) {
            console.error(e);
        }
        getDesc();
    };

    // Preview
    const PreviewHandler = (index) => {
        const html = EditorRef.current[index].getData();
        SetPreviewOpen(html);
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
    const HandleSetPreviewOpen = () => {
        SetPreviewOpen(null);
    };

    // Review
    const handleReviewOpen = (cellnm, revtype, uniqueCode) => {
        SetReviewOpen({
            master: { userId: userSelector.userId },
            sheetcd: data.descCode,
            revision: data.revision,
            tempYn: data.tempYn,
            uniqueCode,
            cellnm,
            revtype,
            positionX: "calc(50% - 200px)",
            // positionY: offsetPosition,
        });
    };

    const renderPage = useMemo(() => {
        if (data) {
            return EditList.map((v, i) => {
                const code = v.replace("desc", "")?.toString().toUpperCase();
                const regex = new RegExp(code, "gi");
                const renderData = data?.[v];
                const revData = data?.reviewData?.filter((f) => f.uniqueCode.match(regex)) || [];

                return (
                    <div key={"ItemPage" + i} className={"ItemPage"}>
                        <div className="d-flex align-center gap-20">
                            <h3
                                className={"title"}
                                onClick={(e) => {
                                    e.target.closest(".ItemPage").classList.toggle("hide");
                                }}
                            >
                                Description {v.replace("desc", "")} <FontAwesomeIcon icon={faAngleUp} />
                            </h3>
                            <button
                                className={"bpl-btn success"}
                                onClick={() => {
                                    PreviewHandler(i);
                                }}
                            >
                                {t("preview")}
                            </button>
                        </div>
                        <div className={"editorbox"}>
                            <DescEditor
                                ref={(e) => {
                                    EditorRef.current[i] = e;
                                }}
                                data={renderData}
                                revData={revData}
                                onOpen={handleReviewOpen}
                                revtype={code.charAt(0)}
                            />
                        </div>
                    </div>
                );
            });
        } else {
            return null;
        }
    }, [data, t]);

    return (
        <>
            <div className="bpl-container" style={{ paddingBottom: "300px" }}>
                <section className="maindesc">
                    <ul className="nav">
                        <li>
                            <p>Project</p>
                            <SearchableSelect
                                name="projectNm"
                                value={inputs.projectNm}
                                search={true}
                                options={projects}
                                border={"ON"}
                                onChange={(val) => {
                                    setInputs((t) => ({
                                        ...t,
                                        projectNm: val.value,
                                    }));
                                }}
                            />
                        </li>
                        <li>
                            <p>Process</p>
                            <SearchableSelect
                                name="process"
                                value={inputs.processCd}
                                search={true}
                                options={procList}
                                border={"ON"}
                                onChange={(val) => {
                                    setInputs((t) => ({
                                        ...t,
                                        processCd: val.value,
                                    }));
                                }}
                            />
                        </li>
                        <li>
                            {RevisionList !== null ? (
                                <div style={{ width: "50%", margin: "0 auto" }}>
                                    <p>Revision</p>
                                    <SearchableSelect
                                        search={true}
                                        value={data?.tempYn === "Y" ? data?.revision + "T" : data?.revision}
                                        options={RevisionList}
                                        border={"ON"}
                                        textAlign={"center"}
                                        onChange={RevisionChange}
                                        revision={true}
                                    />
                                </div>
                            ) : null}
                        </li>

                        <li>
                            {data && (data?.revision === data?.lastVer) && (
                                <div className="btnbox">
                                    <button
                                        className="bpl-btn main"
                                        disabled={data?.userId && userSelector?.userId !== data?.userId}
                                        onClick={() => SetConfirmOpen(true)}
                                    >
                                        {t("save")}
                                    </button>
                                </div>
                            )}
                        </li>
                        <li>
                            {data && (data?.revision === data?.lastVer) &&  (
                                <div className="btnbox">
                                    <button
                                        className="bpl-btn primary"
                                        disabled={data?.userId && userSelector?.userId !== data?.userId}
                                        onClick={SaveFormData}
                                    >
                                        {t("newTempSave")}
                                    </button>
                                </div>
                            )}
                        </li>
                        {/*{data?.userId && userSelector?.userId !== data?.userId && (*/}
                        {data &&(userSelector?.userId !== data.userId) && (
                            <li className={"cannot-save-msg"}>
                                {data?.userNm ? t("ownerDiffrent") + "\n(" + t("ownerDiffrent2") + ": " + data.userNm  + ")" : ""}
                            </li>
                        )}
                    </ul>

                    <div className="content">{renderPage}</div>
                    {PreviewOpen !== null && <PreviewContainer onClose={HandleSetPreviewOpen}>{PreviewOpen}</PreviewContainer>}
                    {ReviewOpen && <ReviewComponent {...ReviewOpen} admin={true} close={SetReviewOpen} commentType={"desc"} ownerUserId={data?.userId} refresh = {getDesc} />}
                    {data && <UnconfirmedList data={data} />}
                </section>
            </div>

            {ConfirmOpen && (
                <ModalPortal>
                    <Confirm
                        onClose={() => SetConfirmOpen(false)}
                        valid={confirmValid}
                        onConfirm={() => onConfirm(SetConfirmOpen)}
                        autoComplete={false}
                    >
                        <p>
                            {t("saveConfirm")}
                            <br />
                            {t("saveConfirm2")}
                        </p>
                        <textarea id="saveMsg" defaultValue="" onFocus={handleConfirmValid} />
                        <span id="mainFormSaveSpan" className={"valid"}>
                            {t("noReason")}
                        </span>
                    </Confirm>
                </ModalPortal>
            )}
            {ModalOpen && <ModalPortal>{ModalOpen}</ModalPortal>}
        </>
    );
};

export default React.forwardRef(MainDesc);
